module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('payback-' + _vm.mappedType, {
    tag: "component",
    attrs: {
      "added": _vm.added,
      "product": _vm.product
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d28b3a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/factsheet/payback/PaybackTextContainer.vue
// module id = 706
// module chunks = 0